<div class="dialog-container">
  <div class="dialog-icon-container">
    <span class="dialog-icon" [ngClass]="data.confirmButtonColor === 'warn' ? 'warning' : 'info'">
      @if (data.iconName) {
        <mat-icon>{{ data.iconName }}</mat-icon>
      } @else {
        @switch (data.confirmButtonColor) {
          @case ('warn') {
            <span>!</span>
          }
          @default {
            <span>?</span>
          }
        }
      }
    </span>
  </div>
  <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
  <mat-dialog-content class="dialog-content">
    <p class="message-text">{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="center">
    @if (!data.hideCancelButton) {
      <button mat-stroked-button class="cancel-button" (click)="onCancel()">{{ data.cancelButtonText }}</button>
    }
    <button mat-flat-button class="confirm-button" [color]="data.confirmButtonColor" (click)="onConfirm()">{{ data.confirmButtonText }}</button>
  </mat-dialog-actions>
</div>
